import { render } from "./UiVideo.vue?vue&type=template&id=03d974cc&ts=true&lang=pug"
import script from "./UiVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiVideo.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__